__turbopack_context__.v({
  "item": "style-module-scss-module__Bh0iFa__item",
  "link": "style-module-scss-module__Bh0iFa__link",
  "linkActive": "style-module-scss-module__Bh0iFa__linkActive",
  "list": "style-module-scss-module__Bh0iFa__list",
  "listWrapper": "style-module-scss-module__Bh0iFa__listWrapper",
  "progressLine": "style-module-scss-module__Bh0iFa__progressLine",
  "progressTrack": "style-module-scss-module__Bh0iFa__progressTrack",
  "title": "style-module-scss-module__Bh0iFa__title",
  "toc": "style-module-scss-module__Bh0iFa__toc",
});
